import React from "react";
import util1 from "../../../assets/join-util1.png";
import util2 from "../../../assets/join-util2.png";
import Logo from "../../../assets/Logo.png";
import { socialLinks } from "../../../utils";

const Join = () => {
  return (
    <div className="join">
      <div className="container pt-20 pb-40 md:pb-80 relative z-10">
        <div className="bg-primary p-10 relative max-w-[800px] mx-auto">
          <img
            src={util1}
            className="absolute top-0 left-full w-20 md:w-40 -translate-y-1/2 -translate-x-1/2"
            alt=""
          />
          <img
            src={util2}
            className="absolute bottom-0 right-full w-20 md:w-40 translate-x-1/2"
            alt=""
          />
          <h2 className="leading-[3rem] text-3xl md:text-4xl text-center">
            Join the
            <br />
            <b>Kings Clan</b>{" "}
          </h2>
          <a
            href="https://t.me/KingsCoinPortal"
            className="bg-white max-w-max py-2 px-4 text-primary font-serif block mx-auto mt-4"
          >
            Join Our Telegram
          </a>
        </div>
      </div>
      <div className="container relative z-10 py-6 flex justify-between items-center">
        <div>
          <img src={Logo} className="w-14" alt="" />
        </div>
        <div className="grid grid-flow-col gap-2 font-serif">
          <p>Join Our Socials:</p>
          <div className="grid grid-flow-col gap-2">
            {socialLinks.map((val, i) => (
              <a href={val.link} key={i} className="text-xl">
                {val.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Join;
